import * as React from 'react';



export default class Logs extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
        <g id="Page-1-Copy" transform="translate(1.000000, 1.000000)">
            <path d="M9.85109375,10.3974474 L11.4010937,10.3974474" id="Stroke-1"></path>
            <g id="Group-12" transform="translate(0.000000, 0.035605)">
                <polygon id="Fill-1" className="strokeColor" stroke="currentColor" fill="currentColor" points="11.0420609 6.05940359 12.46875 6.79903524 12.46875 0.603207237 11.0420609 0.639666745"></polygon>
                <path d="M9.88765625,10.3618421 C9.880625,9.85184211 9.87359375,9.34184211 9.868125,8.83263158" id="Stroke-2"></path>
                <path d="M13.7939844,10.0287632 C13.7939844,12.2290263 12.0283594,14.0132368 9.85101562,14.0132368 C7.67367187,14.0132368 5.90804687,12.2290263 5.90804687,10.0287632 C5.90804687,7.8285 7.67367187,6.04428947 9.85101562,6.04428947 C12.0283594,6.04428947 13.7939844,7.8285 13.7939844,10.0287632 Z" id="Stroke-4"></path>
                <path d="M7.17773438,12.8227895 L0.585546875,12.8227895 C0.369921875,12.8227895 0.194921875,12.6459474 0.194921875,12.4280526 L0.194921875,0.556736842 C0.194921875,0.338842105 0.369921875,0.162 0.585546875,0.162 L12.1707031,0.162 C12.3863281,0.162 12.5613281,0.338842105 12.5613281,0.556736842 L12.5613281,6.91594737" id="Stroke-6"></path>
                <path d="M3.50382812,3.43697368 C3.87179687,3.18986842 4.27335937,2.99565789 4.69445312,2.86144737 C4.73820312,4.64092105 4.66320312,6.5025 4.70695312,8.28118421" id="Stroke-8"></path>
                <path d="M7.4340625,3.43697368 C7.80203125,3.18986842 8.20359375,2.99565789 8.62390625,2.86144737 C8.6684375,4.64092105 8.58171875,3.79302632 8.62546875,5.57171053" id="Stroke-10"></path>
            </g>
        </g>
      </svg>
    )
  }
}
